import React, { useState } from "react";
import {
  useGetIndividualUserCommodityQuery,
  useGetQualityParameterQuery,
  useDisableCommodityMutation,
} from "./ProcurementApiSlice";
import { selectCurrentRoles } from "features/auth/authSlice";
import { useSelector } from "react-redux";
import { Modal, Table } from "react-bootstrap";
import Tooltip from "@mui/material/Tooltip";
import CommoditySpecificSeller from "./ComoditySpecificSeller";
import Switch from "@mui/material/Switch";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import AddStock from "./AddStock";
import SkeletonLoader from "./SkeletonLoader";
import NoData from "features/MobileProcurement/NoData";

const IndividualUserCommodity = ({
  organizationVal,
  user_id,
  availableCommodity,
  userName,
  UserData,
  setActiveCard,
  activeCard,
  refetchFilteredCommodity,
}) => {
  const RolesFromToken = useSelector(selectCurrentRoles);
  const [showModal, setShowModal] = useState(false);
  const [CommodityName, setCommodityData] = useState("");
  const [selectedCommodity, setSelectedCommodity] = useState({});
  const { data: QualityParameter } = useGetQualityParameterQuery(
    selectedCommodity.commodityCode,
    {
      skip: !selectedCommodity.commodityCode,
    }
  );
  const [anchorEl, setAnchorEl] = useState(false);
  const {
    data: IndividualUserCommodity,
    isLoading,
    refetch,
  } = useGetIndividualUserCommodityQuery(user_id);

  // } = useGetIndividualUserCommodityQuery(RolesFromToken?.organization_id);
  // const { data: availableCommodity, refetch: refetchFilteredCommodity } = useGetCommoditiesDataQuery( { user_id: user_id },);
  const [addStock, setAddStock] = useState(false);

  const [ProfileModel, setProfileModel] = useState(false);
  const [listData, setListData] = useState("");
  const [loaderEnable, setLoaderEnable] = useState(false);
  const [updateCommodity] = useDisableCommodityMutation();
  const [cropDetails, setCropDetails] = useState({});
  const hideLeadModal = () => {
    setShowModal(false);
  };

  let uniqueData = new Set();
  if (isLoading) {
    return (
      <div className="mt-3">
        <SkeletonLoader />
      </div>
    );
  }
  const handleClick = (commodityCode, image_url, crop) => {
    setShowModal(true);
    setSelectedCommodity({
      commodityCode: commodityCode,
      image: image_url,
    });
    setCommodityData(crop);
  };
  const handlePopoverClose = () => {
    setAnchorEl(false);
  };
  const handlePopoverOpen = (list) => {
    setAnchorEl(true);
    setCommodityData(list.commodity.name);
  };
  const handleSwitchProfile = (list) => {
    setProfileModel(true);
    setListData(list);
  };
  const handleClose = () => {
    setProfileModel(false);
  };
  const handleDisable = () => {
    setLoaderEnable(true);
    updateCommodity({ id: listData.id })
      .unwrap()
      .then((data) => {
        setLoaderEnable(false);
        toast.success("Successfully Done");
        refetch();
        setProfileModel(false);
      })
      .catch((data) => {
        toast.error(`${data.data.message}`);
        setLoaderEnable(false);
      });
  };
  const availableCommoditySet = new Set(
    availableCommodity?.data.map((item) => item.id)
  );
  const handleStockModal = (item) => {
    setAddStock(true);
    setCropDetails(item);
  };
  return (
    <div
      className="container-fluid mt-2"
      style={{ backgroundColor: "#ebeef380" }}
    >
      {IndividualUserCommodity?.data?.length < 1 ? (
        <NoData val="Commodity"></NoData>
      ) : (
        <div className="row mt-4">
          {IndividualUserCommodity?.data?.map((item, ind) => {
            if (!uniqueData.has(item?.commodity.id)) {
              uniqueData.add(item?.commodity.id);
              const isAvailable = availableCommoditySet.has(item?.commodity.id);
              return (
                <div
                  key={ind}
                  className="col-6 col-sm-12 col-md-4 col-lg-3 col-xl-2 p-2"
                  style={{ opacity: item.is_enabled ? 1 : 0.5 }}
                >
                  <div
                    className={` ${
                      item.is_enabled ? "enabled-card" : "disabled-card"
                    }`}
                    style={{
                      // border: item.is_enabled ? "1px solid #4CAF50" : "1px solid #CCC",
                      borderRadius: "10px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      transition: "transform 0.2s ease-in-out",
                      padding: "12px",
                      textAlign: "center",
                      position: "relative",
                      height: "200px",
                      cursor: "pointer",
                      backgroundColor: item.is_enabled ? "#f0f9f4" : "#fafafa",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.transform = "scale(1.05)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  >
                    {/* Switch for Enable/Disable */}
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                      }}
                    >
                      <Tooltip
                        title={
                          item?.is_enabled
                            ? "Disable Commodity"
                            : "Enable Commodity"
                        }
                      >
                        <Switch
                          size="small"
                          color="success"
                          checked={item?.is_enabled || false}
                          onChange={() => handleSwitchProfile(item)}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </Tooltip>
                    </div>

                    {/* Commodity Image */}
                    <div className="mb-2">
                      <img
                        src={item.commodity.image_url}
                        alt={item.commodity.name}
                        className="rounded-circle img-fluid"
                        style={{
                          height: "100px",
                          width: "100px",
                          objectFit: "cover",
                          backgroundColor: "#fff",
                        }}
                        onClick={() =>
                          handleClick(
                            item?.commodity.code,
                            item?.commodity.image_url,
                            item?.commodity?.name
                          )
                        }
                      />
                    </div>

                    <div className="mb-1">
                      <span
                        style={{
                          fontSize: "12px",
                          color: "#333",
                          fontWeight: "500",
                        }}
                      >
                        {item.commodity.name}
                      </span>
                    </div>

                    <div>
                      <span
                        style={{
                          fontSize: "9px",
                          color: "#FF5722",
                          fontWeight: "bold",
                        }}
                      >
                        {item.commodity.category}
                      </span>
                    </div>

                    {isAvailable &&
                      organizationVal?.procurement_type === "Seller" && (
                        <div
                          className="position-absolute bottom-0 w-100"
                          style={{
                            backgroundColor: "#4CAF50",
                            color: "#fff",
                            padding: "5px",
                            textAlign: "center",
                            borderRadius: "0 0 10px 10px",
                            fontSize: "12px",
                            left: "-2px",
                          }}
                          onClick={() => handleStockModal(item)}
                        >
                          Add Stock
                        </div>
                      )}

                    {!item.is_enabled && (
                      <div
                        className="position-absolute bottom-0 w-100"
                        style={{
                          backgroundColor: "#FF7043",
                          color: "#fff",
                          padding: "5px",
                          textAlign: "center",
                          borderRadius: "0 0 10px 10px",
                          fontSize: "12px",
                          left: "-2px",
                        }}
                        onClick={() => handleSwitchProfile(item)}
                      >
                        Disabled (Click to Enable)
                      </div>
                    )}

                    {!item.is_enabled && (
                      <div
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          backgroundColor: "#FF5722",
                          borderRadius: "50%",
                          padding: "8px",
                          color: "#fff",
                        }}
                      >
                        <i className="mdi mdi-lock"></i>
                      </div>
                    )}
                  </div>
                </div>
              );
            }
          })}
        </div>
      )}
      <Modal show={showModal} onHide={hideLeadModal} size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "" }} className="fw-bold">
            QUALITY PARAMETERS
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "2%" }}>
          <div>
            <div className="row w-100">
              <div className="col-lg-2 col-md-4 col-12 text-center mb-3 mb-md-0">
                <h4 className="mt-2 fw-bold text-wrap">
                  {QualityParameter?.data[0]?.commodity_name}
                </h4>
                <div className="d-flex justify-content-center align-items-center">
                  <img
                    className="img-fluid rounded-circle border"
                    src={selectedCommodity?.image}
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                    }}
                    alt={QualityParameter?.data[0]?.commodity_name}
                  />
                </div>
              </div>

              <div className="col-lg-10 col-md-8 col-12">
                <div className="table-responsive mt-3">
                  <Table
                    striped
                    hover
                    className="mb-0"
                    style={{
                      minWidth: "750px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <thead>
                      <tr className="table-primary">
                        <th className="fs-6">Parameter</th>
                        <th className="fs-6">Range One</th>
                        <th className="fs-6">Range Two</th>
                        <th className="fs-6">Range Three</th>
                      </tr>
                    </thead>
                    <tbody>
                      {QualityParameter?.data?.map((data, index) => (
                        <tr key={index}>
                          <td>{data.fields}</td>
                          <td>{data.range_one}</td>
                          <td>{data.range_two}</td>
                          <td>
                            {data.range_three === "nan"
                              ? "—"
                              : data.range_three}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>

            {organizationVal?.procurement_type === "Buyer" && (
              <CommoditySpecificSeller
                CommodityName={CommodityName}
                organizationVal={organizationVal}
              />
            )}
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={ProfileModel} onHide={handleClose} size="md">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "" }} className="fw-bold">
            {listData?.is_enabled ? "Disable Commodity" : "Enable Commodity"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          <div className="">
            <h6 className="text-gray text-center mt-3">
              Are you Sure you Want to{" "}
              {listData?.is_enabled ? "Disable " : "Enable "}{" "}
              <strong className="text-black">
                {listData?.commodity?.name}
              </strong>{" "}
              ?
            </h6>
          </div>
          <div className="">
            {" "}
            <p className="text-gray text-italic text-bottom  mt-4 mb-0">
              <strong>Note : </strong>
              {listData?.is_enabled
                ? "You will not be able to Trade or perform any actions if they are disabled."
                : "Enabled uses can login and perform actions based on the assigned roles"}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger waves-effect me-2"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-success waves-effect me-2"
            onClick={handleDisable}
          >
            {listData?.is_enabled ? "Disable " : "Enable"}&nbsp;{" "}
            {loaderEnable ? <Spinner size="sm" /> : ""}{" "}
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={addStock}
        onHide={() => setAddStock(false)}
        size="xm"
        centered
      >
        <Modal.Header closeButton className="">
          <Modal.Title className="fw-bold text-primary">Add Stock</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ width: "100%", marginTop: "-2px" }}>
          <AddStock
            user_id={user_id}
            refetch={refetch}
            userName={userName}
            UserData={UserData}
            setActiveCard={setActiveCard}
            activeCard={activeCard}
            cropDetails={cropDetails}
            refetchFilteredCommodity={refetchFilteredCommodity}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default IndividualUserCommodity;
